import {
  ExtendButtonBase,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  Theme,
} from '@mui/material';
import { ListItemButtonTypeMap } from '@mui/material/ListItemButton/ListItemButton';
import { CaretRight } from '@phosphor-icons/react';

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.down('lg')]: {
    '&.homepage': {
      paddingTop: '0.8rem',
    },
  },
  [theme.breakpoints.up('lg')]: {
    '&.homepage': {
      maxWidth: '33%',
    },
  },
})) as typeof ListItem;

export const ListItemIconStyled = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  minWidth: 0,
  alignItems: 'center',
}));

interface AdditionalListItemButtonStyledProps {
  $isCombined: boolean;
  $smallSpacing: boolean;
}

const getPadding = (
  isCombined: boolean,
  smallSpacing: boolean,
  theme: Theme
) => {
  const leftSpacing = isCombined ? 14 : 5;
  const verticalSpacing = smallSpacing ? 2 : 4;

  return theme.spacing(verticalSpacing, 5, verticalSpacing, leftSpacing);
};

export const ListItemButtonStyled = styled(
  ListItemButton
)<AdditionalListItemButtonStyledProps>(
  ({ theme, $isCombined, $smallSpacing }) => ({
    border: $isCombined ? 0 : `0.1rem solid ${theme.palette.grey[200]}`,
    borderRadius: $isCombined ? 0 : theme.shape.borderRadius,
    padding: getPadding($isCombined, $smallSpacing, theme),
    minHeight: '5.6rem',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.common.white,
    '&:focus': {
      border: `0.2rem solid ${theme.palette.primary.main}`,
    },
    '&.Mui-disabled': {
      opacity: 1,
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.grey[400],
    },
  })
) as ExtendButtonBase<
  ListItemButtonTypeMap<AdditionalListItemButtonStyledProps>
>;

export const ListItemTextStyled = styled(ListItemText)(({ theme }) => ({
  margin: 0,
  '.MuiTypography-root': {
    wordWrap: 'break-word',
    [theme.breakpoints.up('lg')]: {
      '&.homepage': {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '85%',
      },
    },
  },
}));

export const ArrowForwardIosTwoToneStyled = styled(CaretRight)(({ theme }) => ({
  fontSize: '1.6rem',
  color: theme.palette.primary.main,
}));
